import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import {
  BULK_COPY_LIMIT,
  BULK_MOVE_LIMIT,
} from '~/common/constants/max_lengths';
import {
  analyzerBulkCopy,
  analyzerBulkMove,
} from '~/components/AnalyzerResultsPage/AnalyzerResultsPage.data';
import EcModal from '~/components/Shared/EcModal/EcModal';
import { showToast } from '~/components/Shared/EcToast/showToast';
import { useIntl } from 'react-intl';
import * as selectors from '~/redux/selectors';
import search from '~/redux/slices/search';
import { MODAL_FOLDER_TREE } from '~/types/modal.types';
import { ERROR, SUCCESS } from '~/types/toast.types';

const CopyMoveSearchResults = ({ onActionComplete, resultsCache = {} }) => {
  const intl = useIntl();
  const modal = useSelector(selectors.selectSearchResultModal);
  const dispatch = useDispatch();
  const hideModal = () => dispatch(search.actions.setModal());
  const pilotSearchQuery = useSelector(selectors.selectPilotSearchQuery);
  const { modalType, context } = modal || {};

  if (modalType !== MODAL_FOLDER_TREE) return null;

  const { bulkAction, isAllRowsSelected, selectedRowIds, totalCount } = context;
  const selectedItems = selectedRowIds.map((id) => resultsCache[id]);
  const selectedDocumentsCount = isAllRowsSelected
    ? totalCount
    : selectedItems.length;
  const limitCountPerActionType =
    bulkAction === 'move' ? BULK_MOVE_LIMIT : BULK_COPY_LIMIT;

  const title =
    bulkAction === 'move'
      ? intl.formatMessage({
          id: 'CopyMoveSearchResults.moveToFolderTitle',
          defaultMessage: 'Move to folder',
          description: 'Title for move to folder modal',
        })
      : intl.formatMessage({
          id: 'CopyMoveSearchResults.copyToFolderTitle',
          defaultMessage: 'Copy to folder',
          description: 'Title for copy to folder modal',
        });

  const buttonTitle =
    bulkAction === 'move'
      ? intl.formatMessage({
          id: 'CopyMoveSearchResults.moveButton',
          defaultMessage: 'Move',
          description: 'Move button text',
        })
      : intl.formatMessage({
          id: 'CopyMoveSearchResults.copyButton',
          defaultMessage: 'Copy',
          description: 'Copy button text',
        });

  const onBulkMoveCopy = (location) => {
    const handlersIds = isAllRowsSelected
      ? []
      : selectedItems.flatMap((document) =>
          document.document_handlers.map((handler) => handler.id),
        );

    const analyzerBulkAction =
      bulkAction === 'move' ? analyzerBulkMove : analyzerBulkCopy;

    analyzerBulkAction(
      location.id,
      handlersIds,
      pilotSearchQuery,
      isAllRowsSelected,
    )
      .then((res) => showToast(SUCCESS, res.detail))
      .catch((err) => showToast(ERROR, err.response.data.detail))
      .finally(() => onActionComplete());
  };

  return (
    <EcModal
      modalType={modalType}
      width="540px"
      title={title}
      folderIdsSelected={[]}
      handleUploadLocationChange={onBulkMoveCopy}
      confirmButtonText={buttonTitle}
      hideModal={hideModal}
      bulkAction={bulkAction}
      overLimit={selectedDocumentsCount > limitCountPerActionType}
      enableSearch={true}
    />
  );
};

export default CopyMoveSearchResults;
